import { Controller } from "@hotwired/stimulus"
import Highcharts from "highcharts"
import 'highcharts/highcharts-more'; 
import 'highcharts/modules/accessibility';

export default class extends Controller {
  static values = {
    bmi: Number,
    legend: String,
  }

  connect() {
    if (this.hasBmiValue && this.bmiValue > 0) {
      this.renderGauge()
    }
  }

  renderGauge() {
    const bmi = this.bmiValue

    Highcharts.chart(this.element, {
      chart: {
        type: 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: 200,
        backgroundColor: 'transparent'
      },

      title: {
        text: null
      },

      credits: {
        enabled: false
      },

      pane: {
        startAngle: -90,
        endAngle: 90,
        background: null,
        center: ['50%', '75%'],
        size: '110%'
      },

      yAxis: {
        min: 15,
        max: 40,
        tickAmount: 6,
        tickPosition: 'outside',
        tickColor: '#E5E7EB',
        tickLength: 8,
        tickWidth: 2,
        minorTickInterval: null,
        labels: {
          distance: 15,
          style: {
            fontSize: '10px',
            color: '#6B7280',
            fontWeight: '500'
          }
        },
        lineWidth: 0,
        plotBands: [{
          from: 15,
          to: 18.5,
          color: '#93C5FD',
          thickness: 22,
          borderRadius: '50%'
        }, {
          from: 18.5,
          to: 25,
          color: '#86EFAC',
          thickness: 22,
          borderRadius: '50%'
        }, {
          from: 25,
          to: 30,
          color: '#FDE047',
          thickness: 22,
          borderRadius: '50%'
        }, {
          from: 30,
          to: 35,
          color: '#FDBA74',
          thickness: 22,
          borderRadius: '50%'
        }, {
          from: 35,
          to: 40,
          color: '#FCA5A5',
          thickness: 22,
          borderRadius: '50%'
        }]
      },

      series: [{
        name: 'BMI',
        data: [bmi],
        tooltip: {
          valueSuffix: ''
        },
        dataLabels: {
          format: '{y:.1f}',
          borderWidth: 0,
          color: '#111827',
          style: {
            fontSize: '26px',
            fontWeight: 'bold'
          }
        },
        dial: {
          radius: '80%',
          backgroundColor: '#565e6f',
          borderWidth: 0,
          baseWidth: 12,
          baseLength: '0%',
          rearLength: '0%'
        },
        pivot: {
          backgroundColor: '#565e6f',
          borderWidth: 0,
          radius: 6
        }
      }]
    })
  }
}
